import type { UpperLetters } from '#types';
import { typeFn } from '#utils/typeFn';

const fn = typeFn<UpperLetters>()();

export default fn;
